import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=1220c7b2&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"
import style0 from "./popup.vue?vue&type=style&index=0&id=1220c7b2&prod&lang=scss&scoped=true"
import style1 from "./popup.vue?vue&type=style&index=1&id=1220c7b2&prod&lang=css"
import style2 from "./popup.vue?vue&type=style&index=2&id=1220c7b2&prod&scoped=true&lang=scss"
import style3 from "./popup.vue?vue&type=style&index=3&id=1220c7b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220c7b2",
  null
  
)

export default component.exports